import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SnackbarProvider } from 'notistack';
import { createBrowserRouter, createRoutesFromChildren, matchRoutes, RouterProvider, useLocation, useNavigationType, } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { AppRoutes } from './routes/AppRoutes';
import { DialogProvider } from './components/Dialog/DialogProvider';
import { AuthProvider } from './contexts/Auth/AuthProvider';
Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
        Sentry.replayIntegration(),
        Sentry.browserTracingIntegration(),
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation: useLocation,
            useNavigationType: useNavigationType,
            createRoutesFromChildren: createRoutesFromChildren,
            matchRoutes: matchRoutes,
        }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.REACT_APP_SENTRY_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE || '1.0.0',
});
var router = createBrowserRouter([
    {
        path: '/*',
        element: (_jsx(AuthProvider, { children: _jsx(AppRoutes, {}) })),
    },
]);
export var App = function () { return (_jsx(DialogProvider, { children: _jsx(SnackbarProvider, { maxSnack: 3, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, children: _jsx(RouterProvider, { router: router }) }) })); };
